import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = "https://www.stellarinfo.com/support/keyCheckerOnTrack.php";
const AUTH_TOKEN = "JNK89GY6ftUNMy56y64d9243352edec3cgbty"; // Replace with actual token

export const fetchLicenseData = createAsyncThunk(
  "license/fetchLicenseData",
  async (licenseKey, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_URL,
        { key: licenseKey },
        {
          headers: {
            Authorization: AUTH_TOKEN,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch license data");
    }
  }
);

const licenseSlice = createSlice({
  name: "license",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLicenseData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLicenseData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchLicenseData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default licenseSlice.reducer;